import * as Type from './actionsTypes';

const loadNsirs = filter => ({ type: Type.NSIRS_FIND, filter });

const importNsirs = (data, callbackAfterSave) => ({ type: Type.NSIRS_IMPORT, data, callbackAfterSave });

const loadNsirById = id => ({ type: Type.NSIRS_FIND_BY_ID, id });

const deleteNsir = (id, callback, options = {}) => ({
  type: Type.NSIRS_DELETE,
  id,
  callback,
  force: Boolean(options.force),
  onRiscoAlto: options.onRiscoAlto,
  onConfirmacao: options.onConfirmacao,
});

const saveNsir  = (data, callback) => ({ type: Type.NSIRS_SAVE, data, callback });

const updateNsir = data => ({ type: Type.NSIRS_UPDATE, data });

const patchNsirAuditoria = data => ({ type: Type.NSIRS_PATCH_AUDITORIA, data });

const iniciarDigitacaoNsir = data => ({ type: Type.NSIRS_INICIAR_DIGITACAO, data });

const trocarDigitadorNsir = data => ({ type: Type.NSIRS_TROCAR_DIGITADOR, data });

const trocarInspetorNsir = data => ({ type: Type.NSIRS_TROCAR_INSPETOR, data });

const cleanSelectedNsir = () => ({ type: Type.NSIRS_CLEAN_SELECTED });

const updateStatus = (data, callback) => ({ type: Type.NSIRS_UPDATE_STATUS, data, callback });

const generateNsirReport = (filter, callback, apenasDigitados = true) => ({
  type: Type.NSIRS_GENERATE_REPORT,
  filter,
  callback,
  apenasDigitados,
});

const generateNsirReportById = data => ({ type: Type.NSIRS_GENERATE_REPORT_BY_ID, data });

const generateInspecaoReport = (filter, callback) => ({ type: Type.NSIRS_GENERATE_INSPECAO_REPORT, filter, callback });

const exportNsirs = (filter, callbackAfterSave) => ({ type: Type.NSIRS_EXPORT, filter, callbackAfterSave });

const exportToEditNsirs = (filter, callbackAfterSave) => ({ type: Type.NSIRS_EXPORT_TO_EDIT, filter, callbackAfterSave });

const exportFinanceiro = (filter, callbackAfterSave) => ({ type: Type.NSIRS_EXPORT_FINANCEIRO, filter, callbackAfterSave });

const importNsirServices = (data, callbackAfterSave) => ({ type: Type.NSIRS_IMPORT_SERVICES, data, callbackAfterSave });

const updateFinanceiro = (data, callback) => ({ type: Type.NSIRS_UPDATE_FINANCEIRO, data, callback });

const importNsirFinanceiro = (data, callbackAfterSave) => ({ type: Type.NSIRS_IMPORT_FINANCEIRO, data, callbackAfterSave });

const exportCcsm = id => ({ type: Type.NSIRS_EXPORT_CCSM, id });

const nsirExport = (path, fileName, filter, callback) => ({ type: Type.NSIRS_BASE_EXPORT, path, fileName, filter, callback });

const defaultNsirImport = (path, data, callback) => ({ type: Type.NSIRS_BASE_IMPORT, path, data, callback });

const generateReportUsoMutuo = (filter, callback) => ({ type: Type.NSIRS_REPORT_USO_MUTUO, filter, callback });

const generateReportPesagemSucata = (filter, callback) => ({
  type: Type.NSIRS_REPORT_PESAGEM_SUCATA,
  filter,
  callback,
});

const generateReportDigitadorDiario = (filter, callback) => ({ type: Type.NSIRS_REPORT_DIGITACAO_DIARIO, filter, callback });

const forceUpdateStatusNsir = (id, status, callback) => ({ type: Type.NSIRS_FORCE_UPDATE_STATUS, id, status, callback });

const clearSimilarity = () => ({ type: Type.NSIRS_SIMILARITY_CLEAR });

const saveNsirForce = (data, callback) => ({ type: Type.NSIRS_SAVE_FORCE, data, callback });

const previewNsirImport = (data, callback) => ({ type: Type.NSIRS_IMPORT_PREVIEW, data, callback });

const cloneNsir = (id, callback) => ({ type: Type.NSIRS_CLONE_NSIR, id, callback });

const batchNsirDigitadores = (data, callback) => ({
  type: Type.NSIRS_BATCH_DIGITADORES,
  data,
  callback,
});

const batchNsirInspetores = (data, callback) => ({
  type: Type.NSIRS_BATCH_INSPETORES,
  data,
  callback,
});

const batchForceUpdateStatusNsir = (data, callback) => ({
  type: Type.NSIRS_BATCH_STATUS,
  data,
  callback,
});

const digitacaoAntecipadaNsir = data => ({ type: Type.NSIRS_DIGITACAO_ANTECIPADA, data });

const batchDigitacaoAntecipadaNsir = (data, callback) => ({
  type: Type.NSIRS_BATCH_DIGITACAO_ANTECIPADA,
  data,
  callback,
});

export {
  loadNsirs,
  importNsirs,
  loadNsirById,
  deleteNsir,
  saveNsir,
  updateNsir,
  patchNsirAuditoria,
  updateStatus,
  cleanSelectedNsir,
  generateNsirReport,
  generateNsirReportById,
  generateInspecaoReport,
  exportNsirs,
  exportToEditNsirs,
  exportFinanceiro,
  iniciarDigitacaoNsir,
  trocarDigitadorNsir,
  trocarInspetorNsir,
  importNsirServices,
  updateFinanceiro,
  importNsirFinanceiro,
  exportCcsm,
  nsirExport,
  defaultNsirImport,
  generateReportUsoMutuo,
  generateReportPesagemSucata,
  generateReportDigitadorDiario,
  forceUpdateStatusNsir,
  clearSimilarity,
  saveNsirForce,
  previewNsirImport,
  cloneNsir,
  batchNsirDigitadores,
  batchNsirInspetores,
  batchForceUpdateStatusNsir,
  digitacaoAntecipadaNsir,
  batchDigitacaoAntecipadaNsir,
}
